import script from "./WriteOffRuleNativeNew.vue?vue&type=script&setup=true&lang=js"
export * from "./WriteOffRuleNativeNew.vue?vue&type=script&setup=true&lang=js"

import "./WriteOffRuleNativeNew.vue?vue&type=style&index=0&id=4f4476f4&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/h5-subscription-client-prod-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f4476f4"]])

export default __exports__